import React from "react";
import Button from "@mui/material/Button";

const ButtonWrapper = ({
  variant,
  disabled,
  onClick,
  color,
  size,
  startIcon,
  endIcon,
  label,
  type,
  sx,
}) => {
  return (
    <div>
      <Button
        sx={{
          borderRadius: "5px",
          padding: '4px 10px',
          cursor: 'pointer',
          letterSpacing: '2px',
          width: '95px',
          ...sx, 
        }}
        variant={variant}
        disabled={disabled}
        onClick={onClick}
        color={color}
        size={size}
        startIcon={startIcon}
        endIcon={endIcon}
        type={type || "button"}
      >
        {label}
      </Button>
    </div>
  );
};

export default ButtonWrapper;
